import { escapeRegExp } from '@/shared/utils/strings';

export const createFuzzyRegex = (searchTerm: string): RegExp => {
    if (!searchTerm) {
        return /.*/;
    }

    const pattern = searchTerm
        .split('')
        .map(char => escapeRegExp(char))
        .join('.*');

    return new RegExp(pattern, 'i');
};
